/** @format */

import { Component } from '@angular/core';

@Component({
	selector: 'scorecard-score-reward',
	templateUrl: './score-reward.component.html',
	styleUrls: ['./score-reward.component.scss'],
	standalone: false
})
export class ScoreRewardComponent {
	public scoreRewardIcon = 'assets/image/dsg_ScoreRewards_Card.svg';
}
